import { useEffect, useState } from 'react';
import { CalendarRangeSheet, type DateRange } from '@/components/ui/calendar';
import type { SunbedWhenSheetProps } from '../types';

export function SunbedWhenSheet({
  isOpen,
  onClose,
  cmsProps,
  selectedFrom,
  selectedTo,
  onSelect,
}: SunbedWhenSheetProps) {
  const [range, setRange] = useState<DateRange | undefined>(
    selectedFrom ? { from: selectedFrom, to: selectedTo ?? undefined } : undefined
  );

  useEffect(() => {
    if (isOpen) {
      setRange(selectedFrom ? { from: selectedFrom, to: selectedTo ?? undefined } : undefined);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (!range?.from) return;
    onSelect({ from: range.from, to: range.to ?? range.from });
    onClose();
  };

  const assistance =
    cmsProps?.assistanceTitle && cmsProps?.assistanceDescription
      ? {
          title: cmsProps.assistanceTitle,
          description: cmsProps.assistanceDescription,
          descriptionForMember: cmsProps.assistanceDescriptionForMember,
        }
      : undefined;

  return (
    <CalendarRangeSheet
      isOpen={isOpen}
      onClose={onClose}
      title={cmsProps?.title}
      subtitle={cmsProps?.subtitle}
      selected={range}
      onSelect={setRange}
      selectLabel={cmsProps?.selectButtonLabel}
      onConfirm={handleConfirm}
      assistance={assistance}
    />
  );
}
